import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Empty, Input} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import {uuid} from "../../../../utils";

const {Search} = Input;
/**
 * creat by tianruojun
 * 选部门组件（树形）
 * @description 一个用来选部门的弹窗组件，可以设置回显和返回选择的部门
 * @class TreeModuleBySelectDept
 * @extends {Component}
 */
export default class SelectedList extends Component {
    static propTypes = {
        /**
         * @text 选中的部门列表
         * @category data
         */
        data: PropTypes.array,
        /**
         * @text 删除或修改部门后的回调
         * @category event
         */
        onSelect: PropTypes.func,
        /**
         * @text 删除或修改部门后的回调
         * @category event
         */
        showRightSearch: PropTypes.bool
    };
    static defaultProps = {
        data: [],
        showRightSearch: true,
        onSelect: (dept, call) => {
            console.log("选中的部门数据========", dept);
            call && call(true)
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.data != this.state.data) {
            this.setState({data: nextProps.data})
        }
    }

    render() {
        const {showRightSearch} = this.props;
        return (
            <div style={{flex: 1, border: '1px solid #d9d9d9', position: "relative"}}>
                {showRightSearch ? this.renderRightSearch() : null}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                    <div></div>
                    <Button type="link" onClick={() => {
                        this.state.selectList = [];
                        this.setState({}, () => {
                            this.props.onSelect([])
                        });
                    }}>移除全部</Button>
                </div>
                {this.renderRightList()}
            </div>
        )
    }

    renderRightSearch = () => {
        return (
            <div style={{padding: '9px 17px', borderBottom: '1px solid #f0f0f0'}}>
                <Search
                    placeholder={'请输入关键字'}
                    allowClear={true}
                    onChange={(e) => {
                        let val = e.target.value;
                        this.setState({searchText: val})
                    }}
                    onSearch={(val) => {
                        this.setState({searchText: val})
                    }}
                />
            </div>
        )
    };

    renderRightList = () => {
        const {height} = this.props;
        let {data = [], searchText = ""} = this.state;
        let dataLength = data.length;
        return (
            <div style={{padding: '20px 0px 0px 10px'}}>{
                dataLength > 0 ? <Scrollbars autoHide style={{height: height - 51 - 40 - 32}} key={uuid()}>
                        {
                            data && data.length && data.map(item => {
                                let hide = false;
                                if (searchText && searchText.length) {
                                    hide = item.title?.indexOf(searchText) == -1
                                }
                                const index = item.title.indexOf(searchText);
                                const beforeStr = item.title.substr(0, index);
                                const afterStr = item.title.substr(index + searchText.length);
                                const title =
                                    index > -1 ? (
                                        <span style={{
                                            width: 260,
                                            overflow: 'hidden',
                                            marginLeft: '5px',
                                            textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                        }}>
                                            {beforeStr}
                                            <span style={{color: '#f50'}}>{searchText}</span>
                                            {afterStr}
                                        </span>
                                    ) : (
                                        <span style={{
                                            width: 260,
                                            overflow: 'hidden',
                                            marginLeft: '5px',
                                            textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                        }}>{item.title}</span>
                                    );
                                return (
                                    <div
                                        key={item.key}
                                        style={{
                                            display: hide ? 'none' : 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}>
                                        {title}
                                        <Button type={"link"} onClick={() => {
                                            this.setState({data: data.filter(dataItem => dataItem.key != item.key)}, () => {
                                                this.props.onSelect(this.state.data);
                                            })
                                        }}>移除</Button>
                                    </div>
                                )
                            })
                        }   </Scrollbars> :
                    <div style={{position: "absolute", top: '50%', marginTop: '-100px', marginLeft: 50}}><Empty/></div>}
            </div>
        )
    };

}